import type { Queues } from './common'

type QueueGroup = Extract<keyof Queues, string>
type QueueName<TGroup extends QueueGroup> = Extract<keyof Queues[TGroup], string>
type QueuePath<TGroup extends QueueGroup, TName extends QueueName<TGroup>> = `/queues/${TGroup}/${TName}`

const getQueuePath = <TGroup extends QueueGroup, TName extends QueueName<TGroup>>(
  group: TGroup,
  name: TName,
): QueuePath<TGroup, TName> => {
  return `/queues/${group}/${name}` as QueuePath<TGroup, TName>
}

// ----- SIGNING QUEUE -----
const SIGNING = {
  READY_FOR_SIGNING: getQueuePath('signing', 'readyForSigning'),
  MANUAL_HANDLING: getQueuePath('signing', 'manualHandling'),
  IN_PROGRESS: getQueuePath('signing', 'inProgress'),
  SIGNED: getQueuePath('signing', 'signed'),
}

// ----- PROCUREMENT QUEUE -----
const PROCUREMENT = {
  READY_FOR_ORDER: getQueuePath('procurement', 'readyForOrder'),
  WAITING_DOCUMENT_CONFIRMATION: getQueuePath('procurement', 'waitingDocumentConfirmation'),
}

// ----- FINANCE QUEUE -----
const FINANCE = {
  READY_FOR_FINANCE: getQueuePath('finance', 'readyForFinance'),
}

// ----- FINALIZATION QUEUE -----
const FINALIZATION = {
  READY_FOR_FINALIZATION: getQueuePath('finalization', 'readyForFinalization'),
}

export const PORTAL_QUEUES = {
  SIGNING,
  PROCUREMENT,
  FINANCE,
  FINALIZATION,
} as const
